import { RefreshCw } from "lucide-react";
import { Tag } from "~/components/ui";
import { type FunctionComponent } from "react";

interface ChatStatusTagProcessingProps {
  statusLabel: string;
}

export const ChatStatusTagProcessing: FunctionComponent<ChatStatusTagProcessingProps> = ({ statusLabel }) => {
  return (
    <Tag color="processing" className="inline-flex items-center gap-1">
      <RefreshCw className="animate-spin" size={12} />
      {statusLabel}
    </Tag>
  );
};
